import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AuthService,
  ConfigModule,
  CrossSiteRequestForgeryService,
  CustomLoginGuard,
  GlobalMessageService,
  NotAuthGuard,
  WindowRef,
} from '@spartacus/core';
import { LoginFormComponentService } from '@spartacus/user/account/components';
import { CustomLoginFormComponentService } from './components/custom-login-form/custom-login-form-component.service';
import { CustomLoginComponent } from './components/custom-login-form/custom-login-form.component';
import { ComponentsModule } from './components/components.module';
import { CustomCsrfService } from './services/custom-csrf.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ComponentsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ReturningCustomerLoginComponent: {
          component: CustomLoginComponent,
          providers: [
            {
              provide: LoginFormComponentService,
              useClass: CustomLoginFormComponentService,
              deps: [AuthService, GlobalMessageService, WindowRef],
            },
          ],
        },
        ReturningCustomerRegisterComponent: {
          component: '',
        },
      },
    }),
  ],
  providers: [
    {
      provide: CrossSiteRequestForgeryService,
      useClass: CustomCsrfService,
    }
  ]
})
export class CustomLoginModule {}
